module.exports = __webpack_public_path__ + "static/media/08.microsoft-word.727afbc9.svg";